import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";
import {AppState} from "../../../store";
import {Store} from "@ngrx/store";
import {getFilterByKey} from "../../../store/selectors/filter.selector";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";


@UntilDestroy()
@Component({
  selector: 'brt-school-subjects-filter-footer',
  templateUrl: './school-subjects-filter-footer.component.html',
  styleUrls: ['./school-subjects-filter-footer.component.scss']
})
export class SchoolSubjectsFilterFooterComponent implements Overlayable, OnInit{
  @Output("onClosed") onClosed = new EventEmitter<boolean>();

  filterKey = "";
  activeElementsNumber = 0;
  constructor(private store: Store<AppState>) {
  }

  ngOnInit() {
    this.store.select(getFilterByKey(this.filterKey)).pipe(untilDestroyed(this)).subscribe((val) => {
      this.activeElementsNumber = val.length;
    })
  }

  resetAll() {
    this.onClosed.emit(true);
  }
}
